import { CaretDownIcon } from '@radix-ui/react-icons';
import * as NavigationMenu from '@radix-ui/react-navigation-menu';
import { useRef } from 'react';

import { NavigationLink } from './NavigationLink';
import { NavigationSection } from './types';

import styles from './desktopNavigation.css';
import { buttonText } from './sharedNavStyles.css';

interface DesktopNavigationProps {
  /** The configuration for the displayed sections and links. */
  sections: readonly NavigationSection[];
}
export function MultiSectionNav({ sections }: DesktopNavigationProps) {
  const dialogRef = useRef<HTMLDialogElement>(null);
  return (
    <>
      {sections.map(({ sectionLabel, links }: NavigationSection) => (
        <NavigationMenu.Item key={sectionLabel}>
          <NavigationMenu.Trigger className={styles.navigationMenuTrigger}>
            <span className={buttonText}>{sectionLabel}</span>
            <CaretDownIcon className={styles.caretDown} aria-hidden />
          </NavigationMenu.Trigger>
          <NavigationMenu.Content className={styles.navigationMenuContent}>
            {links.map((link) => (
              <NavigationLink
                key={link.to}
                link={link}
                compact={false}
                onClick={() => dialogRef?.current?.close()}
                disabled={link.disabled}
                className={styles.navigationMenuLink}
              />
            ))}
          </NavigationMenu.Content>
        </NavigationMenu.Item>
      ))}
    </>
  );
}
